import './ForgotPasswordEmailPage.scss'
import { TextField, Typography } from '@mui/material'
import GGButton from '../../../CommonComponents/GGButton/GGButton';
import Lottie from 'lottie-react';
import loaderLottie from '../../../../assets/lottie_animations/bubble-loader.json';
import { PasswordResetFlowController } from '../hooks/usePasswordResetFlow';

interface ForgotPasswordEmailPageProps {
    flow: PasswordResetFlowController
}

const ForgotPasswordEmailPage = ({ flow }: ForgotPasswordEmailPageProps) => {
  return (
    <div className='forgot-password-email-page'>
        <Typography fontWeight={1000} marginBottom={"15px"}>Please enter your registered email address</Typography>

        <TextField label='Enter your email' value={flow.email} fullWidth onChange={(event) => flow.setEmail(event.target.value)}
            helperText={
                 <Typography sx={{color:'red'}} variant='caption'>{flow.error}</Typography>
            }/>
        {
            flow.isLoading ? 
            <Lottie className="loader-lottie" animationData={loaderLottie} loop={true}></Lottie> : 
            <GGButton className='btn-primary' onClick={flow.sendOtp} variant='contained'> 
                Send OTP 
            </GGButton>
        }
    </div>
  )
}


export default ForgotPasswordEmailPage